import { lighten, transparentize } from 'polished';
import styled from 'styled-components';

export const HeaderC = styled.header`
  .navbar {
    margin-left: 0 !important;
    background-color: ${props => props.theme.colors.thirdBackground} !important;
    display: flex;

    .container {
      display: flex;
      align-items: center;

      .logo-vrio {
        width: 209px;
        padding-right: 15px;
        text-align: center;
      }
    }

    .sidebar-toggle {
      padding: 15px 17px;
      font-size: 17px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1) !important;
      }
    }
  }

  .navbar-custom-menu {
    display: flex;
    align-items: center;

    .navbar-nav {
      height: 100%;
      display: flex;
      align-items: center;

      .user-menu {
        display: flex;
        width: 56px;
        margin-right: 19px;

        .user-sair {
          display: flex;
          align-items: center;

          a {
            color: ${props => props.theme.colors.primaryText};
          }

          &:hover {
            background: ${transparentize(0.9, '#000')};
          }
        }
      }

      .contrast-line {
        svg {
          position: absolute;
          top: 5px;
          right: 4px;
          color: ${props => props.theme.colors.primaryText};
        }
      }

      .contrast-line,
      .a-plus,
      .a-less {
        border-radius: 50%;
        padding: 10px;
        width: 25px;
        height: 25px;
        margin-right: 20px;
        background: ${transparentize(0.9, '#000')};

        &:hover {
          background: ${props =>
            lighten(0.05, props.theme.colors.thirdBackground)};
          cursor: pointer;
        }
      }
      .a-plus,
      .a-less {
        p {
          position: relative;
          font-size: 1.4rem;
          top: -8px;
          right: 5px;
          font-weight: 500;
          color: ${props => props.theme.colors.primaryText};

          span {
            position: absolute;
            top: -9px;
            right: -13px;
            font-size: 2.4rem;
          }
        }
      }

      .a-plus {
        p {
          span {
            font-size: 1.4rem;
            top: -1px;
          }
        }
      }
    }

    .dropdown-toggle {
      display: flex;
      align-items: center;
      padding: 0 15px;

      .hidden-xs {
        font-size: 1.4rem;
      }

      > .MuiAvatar-root {
        margin-right: 10px;
      }
    }

    .user-menu {
      height: 100%;
      cursor: pointer;

      .dropdown-menu {
        background: #262525;
        border: 0;
        width: 175px;
        top: 54px;

        li {
          background: #262525;
          border: 0;

          a {
            background: #201f1f;
            border: 0;
          }
        }
      }
    }
  }
`;

export const SidebarC = styled.aside`
  padding-top: 54px;
  background-color: ${props =>
    props.theme.colors.secondaryBackground} !important ;

  li.header {
    background: ${props => transparentize(0.9, '#000')} !important;
  }

  .sidebar {
    font-size: 11px;

    .sidebar-menu {
      li {
        color: ${props => props.theme.colors.thirdText};

        a {
          color: ${props => props.theme.colors.primaryText};

          &:hover {
            color: ${props => props.theme.colors.secondaryText};
            background: ${props =>
              lighten(0.05, props.theme.colors.secondaryBackground)};
          }

          i {
            position: relative;
            top: 1px;
            left: -1px;
          }
          span {
            padding: 12px 5px 12px 3px !important;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    padding-top: 53px;
  }
`;
